// src/config/tenants.ts

export interface TenantColors {
  primary: string;
  primaryHover: string;
  accent: string;
  accentHover: string;
  text: string;
  background: string;
}

export interface TenantConfig {
  id: string;
  name: string;
  domain: string;
  logo?: string;
  placeholderImage: string;   // ← NEW: path to brand-specific placeholder asset
  colors: TenantColors;
  meta: {
    title: string;
    tagline: string;
    description: string;
  };
  searchConfig?: {
    brandFilter: string;
    yearRange: { min: number; max: number };
    horsePowerRange: { min: number; max: number };
  };
}

export const TENANTS: Record<string, TenantConfig> = {
  porsche: {
    id: 'porsche',
    name: 'Porsche',
    domain: 'porsche.mynextclassic.net',
    placeholderImage: '/assets/images/porsche-placeholder-cut.png',
    colors: {
      primary: '#E03C31',
      primaryHover: '#c4342a',
      accent: '#00C2A8',
      accentHover: '#00a892',
      text: '#F2F4F8',
      background: '#111315',
    },
    meta: {
      title: 'MyNextClassic Porsche',
      tagline: 'Cars Found',
      description: 'Premium marketplace for classic Porsche collector cars.',
    },
    searchConfig: {
      brandFilter: 'Porsche',
      yearRange: { min: 1989, max: 1999 },
      horsePowerRange: { min: 250, max: 450 },
    },
  },
  mercedes: {
    id: 'mercedes',
    name: 'Mercedes-Benz',
    domain: 'mercedes.mynextclassic.net',
    placeholderImage: '/assets/images/mercedes-placeholder.png',   // ← add this image to your assets
    colors: {
      primary: '#00ADEF',
      primaryHover: '#0099CC',
      accent: '#00C2A8',
      accentHover: '#00a892',
      text: '#F2F4F8',
      background: '#111315',
    },
    meta: {
      title: 'MyNextClassic Mercedes',
      tagline: 'Cars Found',
      description: 'Premium marketplace for classic Mercedes-Benz collector cars.',
    },
    searchConfig: {
      brandFilter: 'Mercedes-Benz',
      yearRange: { min: 1980, max: 2000 },
      horsePowerRange: { min: 60, max: 500 },
    },
  },
};

export const getCurrentTenant = (): TenantConfig => {
  if (typeof window === 'undefined') {
    return TENANTS.porsche;
  }
  const urlParams = new URLSearchParams(window.location.search);
  const tenantParam = urlParams.get('tenant');
  if (tenantParam && TENANTS[tenantParam]) {
    return TENANTS[tenantParam];
  }
  const hostname = window.location.hostname;
  const tenant = Object.values(TENANTS).find(t => t.domain === hostname);
  return tenant || TENANTS.porsche;
};

export const getTenantById = (id: string): TenantConfig | undefined => {
  return TENANTS[id];
};